<div class="content wz-table-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">cultures</span></h2>
  </div>

  <p class="wz-lead">Add details to steer the AI for each culture. <strong>Everything here is optional</strong>: leave a row blank and the AI decides.</p>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Chaos Level Row -->
    <div class="chaos-level-row mb-4 d-flex align-items-center justify-content-center gap-3">
      <label for="cultureChaosLevel" class="chaos-label fw-bold">Chaos level</label>
      <div class="select-wrapper custom-select-width">
        <ng-select class="wt-select" id="cultureChaosLevel" [(ngModel)]="cultureChaosLevel" [items]="chaosLevels"
          placeholder="Choose…" [clearable]="false" appendTo="body">
          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Table Container -->
    <div class="table-container mx-auto">
      <table class="cultures-table w-100">
        <thead>
          <tr>
            <th class="col-name text-left">Name</th>
            <th class="col-temp text-left">Temperament</th>
            <th class="col-exp text-left">Expansion Drive</th>
            <th class="col-notes text-left">Notes</th>
          </tr>
        </thead>
        <tbody>
          @for (culture of culturesList; track culture; let i = $index) {
            <tr>
              <!-- Name -->
              <td class="col-name">
                <span class="culture-name-text">{{ culture.name }}</span>
              </td>
              <!-- Temperament -->
              <td class="col-temp">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="culture.temperament" [items]="temperaments"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Expansion Drive -->
              <td class="col-exp">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="culture.expansionDrive" [items]="expansionDrives"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Notes -->
              <td class="col-notes">
                <input type="text" class="form-input" [(ngModel)]="culture.notes"
                  placeholder="Notes for {{ culture.name }} (optional)" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

    </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

  </div>
